import { Linkedin } from "lucide-react";

const variants = {
  pill: "rounded-full px-3 py-1.5 text-xs hover:bg-lavender focus-visible:bg-lavender active:bg-lavender",
  underline: "text-sm underline-offset-4 hover:underline focus-visible:underline active:underline",
};

export default function LinkedInLink({ href, children, variant = "underline", className = "", testid }) {
  if (!href) return null;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Stephanie Madojemu on LinkedIn (opens in a new tab)"
      data-testid={testid}
      className={`inline-flex min-h-[32px] items-center gap-1.5 font-medium text-plum outline-none transition-colors duration-200 focus-visible:ring-2 focus-visible:ring-plum/40 ${variants[variant]} ${className}`}
    >
      <Linkedin aria-hidden="true" className="h-4 w-4 shrink-0" strokeWidth={2} />
      <span>{children}</span>
    </a>
  );
}
